import { Component, EventEmitter, Output } from '@angular/core';
import {
  CcdlDividerComponent,
  CcdlLinkComponent,
} from '@cpm-pr1618001/ng-design-lib';

@Component({
  selector: 'mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrl: './mobile-menu.component.scss',
  imports: [CcdlLinkComponent, CcdlDividerComponent],
  standalone: true,
})
export class MobileMenuComponent {
  @Output() signInViewEmitter: EventEmitter<void> = new EventEmitter<void>();

  @Output() signUpViewEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output() closeDialogMenuEmitter: EventEmitter<void> =
    new EventEmitter<void>();

  closeDialogMenuClick(): void {
    this.closeDialogMenuEmitter.emit();
  }

  signInClick(): void {
    this.signInViewEmitter.emit();
  }

  signUpClick(): void {
    this.signUpViewEmitter.emit();
  }
}
